module.exports = __webpack_public_path__ + "05_mole.387d33b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer2/05_mole.png
// module id = 8zB7
// module chunks = 0